import { useState } from "react";
import { IShift } from '../../Types/models';
import { useAuthContext } from "../../contexts/AuthContext";
import UserImage from "../UserImage";
import useShiftService from "../../pages/services/ShiftService";
import { AgendaShift, AgendaUser } from "../../graphql/API";
import useDateService from "../../pages/services/DateService";
import useHelperService from '../../pages/services/HelperService';
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate} from "react-router-dom";
import useShiftApplicationService from "../../pages/services/ShiftApplicationService";
import CustomModal from "../Modals/CustomModal";
import { format } from "date-fns";
import Cookies from "js-cookie";
import { enUS, fr } from 'date-fns/locale';
import { IoArrowRedoCircleOutline } from "react-icons/io5";


interface IShiftProps {
    shift: IShift;
    includedDetails?: boolean;
    isNew?: boolean;
    locale: string;
    conflicted?: boolean;
    user: AgendaUser;
    nav: string;
    managers: AgendaUser[];
};

const Shift = ({shift, includedDetails = false, isNew = false, locale = "en", conflicted, user, nav, managers}: IShiftProps) => {
    // AUTH
    const {userId: AuthUserId} = useAuthContext();
    // I18N
    const { t } = useTranslation();
    // const savedLang = Cookies.get('language');
    // const [locale, setLocale] = useState("en");
    // NAVIGATION
    const navigate = useNavigate();
    // SERVICES
    const {truncate} = useHelperService();
    const {onUpdateShiftAccept} = useShiftService(
        shift as unknown as AgendaShift, user?.type == "MANAGER" && true, locale, shift?.startAt?.split("T")[0], nav, managers);
    // BUTTONS
    const [loadingButton, setLoadingButton] = useState(false);
    // MODAL
    const [contentModal, setContentModal] = useState(null);
    const [linkModal, setLinkModal] = useState(null);
    const [showCustomModal, setShowCustomModal] = useState(false);
    const [footerModal, setFooterModal] = useState(true);

    const {getTIMEZONE, getDateTimeWithTimezone, isNowGreater} = useDateService();
    const TIMEZONE = getTIMEZONE();

    const startAt = new Date(shift.startAt);
    startAt.setHours(startAt.getHours() - TIMEZONE);
    const stopAt = new Date(shift.stopAt);
    stopAt.setHours(stopAt.getHours() - TIMEZONE);

    // const alreadyStarted = isNowGreater(new Date(shift.startAt), TIMEZONE);
    // const alreadyDone = isNowGreater(new Date(shift.stopAt), TIMEZONE);

    const acceptShift = async () => {
        setShowCustomModal(false);
        if (loadingButton) return;
        setLoadingButton(true);
        await onUpdateShiftAccept();
        setLoadingButton(false);
    }

    const goToShift = () => {
        navigate(`${t('link.shift')}/${shift.shiftId}`, { state: { refetchData: true } });
    }

    const applyOnShift = () => {
        setFooterModal(false);
        setContentModal(
            <>
                <Modal.Header>
                <Modal.Title>{t('shift.areYouSure')}</Modal.Title>
                </Modal.Header>
        
                <Modal.Body>
                <p>{t('shift.acceptedMessage')}</p>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
                Cancel
                </Button>
                <Button variant="primary" onClick={ () => acceptShift()}>
                {t('home.apply')}
                </Button>
            </Modal.Footer>
            </>);
        setShowCustomModal(true);
    };

    const getLanguage = () => {
        switch (locale) {
            case 'en':
            return enUS
            case 'fr':
            return fr
            default:
            return enUS
        }
    }

    return (
        <>
            <CustomModal
                show={showCustomModal}
                onHide={() => setShowCustomModal(false)}
                link={linkModal}
                children={contentModal}
                isFooter={footerModal}
                // animation={true}
            />
            <div
            className="p-3 flex-fill bg-white border rounded-4 shadow-sm hover:shadow-md transition" // can remove flex-will
            key={`user_${shift.shiftId}`}
            >
            <Row className="g-3 align-items-center">
                {/* Avatar */}
                <Col xs={12} md={6} className="d-flex flex-column align-items-start flex-shrink-0 w-auto">
                <div className="flex-grow-2">
                    <p>
                    <Link to={`${t('link.user')}/${shift.userId}`} className="text-decoration-none text-dark fw-bold link">
                        {shift.username}
                    </Link>
                    </p>
                    <p style={{fontSize: 10}}>{t('shift.startAt')}{format(startAt, "EEEE d MMMM, HH:mm", {locale: getLanguage()})}</p>
                    <p style={{fontSize: 10}}>{t('shift.stopAt')}{format(stopAt, "EEEE d MMMM, HH:mm", {locale: getLanguage()})}</p>
                </div>
                <div className="flex-grow-2 mb-2" style={{position: 'relative'}}>
                    { shift.accepted ?
                    <>
                        <p style={{fontSize: 10, color: 'green'}}>{t('shift.accepted')}</p>
                        {shift.confirmed ?
                        <p style={{color: 'green', textAlign: 'center'}}>{t('shift.confirmed')}</p>
                        : 
                        <p>{t('shift.awaitingConfirmation')}</p>
                        }
                    </>
                    :
                    (AuthUserId === shift.userId || user.type === "MANAGER") &&
                        <Button variant="success" title={loadingButton ? t('signup.loading') : t('shift.accept')} onClick={() => applyOnShift()} >{t('shift.accept')}</Button>
                    }
                    {isNew && (<span className="new" style={{top: 0,left: 120}}>{t('shift.new')}</span>)}
                </div>
                {/* <div className="flex-grow-2">
                    { shift.confirmed ?
                    <p style={{fontSize: 10, color: 'green'}}>{t('shift.confirmed')}</p>
                    :
                    (AuthUserId === shift.userId || user.type === "MANAGER") &&
                        <Button variant="success" title={t('shift.confirm')} onClick={() => confirmOnShift(shift)} >{t('shift.confirm')}</Button>
                    }
                </div> */}
                </Col>

                {/* Infos utilisateur */}
                <Col className="ps-3">
                <div className="flex-grow-1">
                    <p>{t('shift.title')}{shift.role}</p>
                    <p>{t('shift.location')}{shift.location}</p>
                    <p>{t('shift.information')}{shift.info}</p>
                </div>
                </Col>
                <Col className="ps-3 ms-auto d-flex justify-content-end">
                <div className="flex-grow-2">
                    <IoArrowRedoCircleOutline onClick={() => goToShift()} className="hover-icon" size={80}/>
                </div>
                </Col>
            </Row>
            </div>
        </>
    );
};

export default Shift;